import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import i18n from 'i18next';

const Seo = ({ title, description, keywords }) => {
  return (
    <Helmet
      title={title}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          name: 'keywords',
          content: keywords.join(),
        },
      ]}
      link={[{ rel: 'canonical', href: `https://bundleloan.com${window.location.pathname}` }]}
    />
  );
};

Seo.propTypes = {
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  description: PropTypes.string,
};

Seo.defaultProps = {
  keywords: [],
  title: i18n.t('meta.Seo.title'),
  description: i18n.t('meta.Seo.description'),
};

export default Seo;



// WEBPACK FOOTER //
// ./src/sharedComponents/Seo/Seo.js